import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyADcq3BCOWT2y9dMuxkACpWl3ij9L0Csqs",
  authDomain: "lets-eat-something.firebaseapp.com",
  projectId: "lets-eat-something",
  storageBucket: "lets-eat-something.firebasestorage.app",
  messagingSenderId: "63997201037",
  appId: "1:63997201037:web:8872b1c78c87454b43b0c4",
  measurementId: "G-ZEJ25301NM"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const db = getFirestore(app);

// Configure Google Provider
googleProvider.setCustomParameters({
  prompt: 'select_account'
});

export default app; 